import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    subcategories: [],
    subcategory: null,
    links: null,
    meta: null,
    filterData: {},
    filterDialogOpen: false,
    filterOptionItems: [],
    filterSelectOptionItems: [],
    filter: {
      buId: '',
      keyword: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        buId: '',
        keyword: '',
        status: '',
      };
      state.subcategories = [];
      state.subcategory = null;
    },
    SET_SUBCATEGORIES(state, data) {
      state.subcategories = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SUBCATEGORY(state, data) {
      state.subcategory = data;
    },
    SET_FILTER_DATA(state, data) {
      state.filterData = data;
    },
    TOGGLE_FILTER_DIALOG(state, data) {
      state.filterDialogOpen = data;
    },
  },

  getters: {
    specs(state) {
      if (state.subcategory) {
        return state.subcategory.specs.filter((item) => !item.is_customized);
      }
      return [];
    },
    customizedSpecs(state) {
      if (state.subcategory) {
        return state.subcategory.specs.filter((item) => item.is_customized);
      }
      return [];
    },
    filters(state) {
      if (state.subcategory) {
        return state.subcategory.specs.filter((item) => item.is_filter);
      }
      return [];
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setSubCategory({ commit }, data) {
      commit('SET_SUBCATEGORY', data);
    },

    setFilterData({ commit }, data) {
      commit('SET_FILTER_DATA', data);
    },

    toggleFilterDialog({ commit }, data) {
      commit('TOGGLE_FILTER_DIALOG', data);
    },

    find({ commit, state }) {
      let url = `/product_subcategories?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('SubCategory'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SUBCATEGORIES', response);
        });
    },

    findById({ commit }, id) {
      return http(`/product_subcategories/${id}`)
        .then((response) => response.body)
        .then(typeAs('SubCategory'))
        .then((item) => {
          commit('SET_SUBCATEGORY', item);
          return item;
        });
    },

    destroy(_, id) {
      return http(`/product_subcategories/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    publish(_, data) {
      const request = http('/product_subcategories/publish', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/product_subcategories/${id}`, { method: 'PUT', data })
        : http('/product_subcategories', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    allByCategory(_, id) {
      return http(`/product_categories/${id}/product_subcategories`)
        .then((response) => response.body);
    },
    // 依選定的filter帶出相關資訊
    findFilterByCategory(_, id) {
      return http(`/product_subcategories/${id}/product_filters`)
        .then((response) => response.body);
    },
  },
};
